import { render, staticRenderFns } from "./ed-inline-msg-box.vue?vue&type=template&id=3bead9fb&scoped=true&"
import script from "./ed-inline-msg-box.ts?vue&type=script&lang=ts&"
export * from "./ed-inline-msg-box.ts?vue&type=script&lang=ts&"
import style0 from "./ed-inline-msg-box.scss?vue&type=style&index=0&id=3bead9fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bead9fb",
  null
  
)

export default component.exports